

import { Nav } from 'react-bootstrap';
import { KTSVG } from '../../_metronic/helpers';
/**
 * NavMenu Component
 *
 * Renders a navigation tab menu with status indicators and optional right-side summary.
 *
 * Features:
 * - Displays navigation tabs from the provided nav array
 * - Shows status icons for each tab (completed/not completed)
 * - Optionally displays summary status on the right side
 * - Customizable container class via props
 *
 * Props:
 * - nav: Array of navigation items with id, name, and status
 * - rightSide: Boolean to show/hide right-side summary (default: true)
 * - className: Custom class name for container (default provided)
 */
const NavMenu = ({ nav, rightSide = true, className = 'app-container d-flex flex-stack container-fluid mb-10 pt-2 mx-0' }) => {

    return <>

        <div style={{ borderBottom: "1px solid #ededed", borderTop: "1px solid #ededed" }} className={className}>
            <Nav className="nav nav-stretch nav-line-tabs nav-line-tabs-2x fs-4 fw-semibold border-transparent">
                {nav.map((menu, index) => {
                    return <Nav.Item className='p-2'>
                        <Nav.Link className='text-dark fw-semibold text-active-primary me-0' eventKey={menu.id}>
                            {menu.name}
                        </Nav.Link>
                        <div className='mt-2 ms-2'>
                            {menu.status ?
                                <KTSVG path='/media/icons/duotune/arrows/arr016.svg' style={{ background: '#000' }} className='svg-icon svg-icon-4 svg-icon-success' />
                                : <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon svg-icon-4 fw-dark svg-icon-danger' />
                            }
                        </div>
                    </Nav.Item>
                })}
            </Nav>
            {rightSide &&
                <div className="d-flex fs-7">
                    <div className='me-2'>
                        <KTSVG path='/media/icons/duotune/arrows/arr016.svg' style={{ color: '#000' }} className='svg-icon svg-icon-4 svg-icon-success' />
                        <span className='fw-semibold '>All is done </span>
                    </div>
                    <div className=''>
                        <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon svg-icon-4 fw-dark svg-icon-danger' />
                        <span className='fw-semibold'>Not completed</span>
                    </div>
                </div>
            }
        </div>
    </>
}
export { NavMenu }
